import { Popup } from 'react-map-gl/mapbox'

const rendaFormat = {
	ca: new Intl.NumberFormat('ca-ES', { maximumFractionDigits: 0 }),
	es: new Intl.NumberFormat('es-ES', { maximumFractionDigits: 0 }),
}

export default function Tooltip({ hoverInfo, lang, textos, popupComponent: PopupComponent = Popup }) {
	if (!hoverInfo) return null

	const { dades, longitude, latitude } = hoverInfo
	const rendaValor = Number(dades['renda neta'])
	const renda =
		Number.isFinite(rendaValor) && rendaValor > 0
			? `${rendaFormat[lang === 'es' ? 'es' : 'ca'].format(rendaValor)}€`
			: 's.d.'

	return (
		<PopupComponent
			longitude={longitude}
			latitude={latitude}
			offset={12}
			maxWidth='217px'
			closeButton={false}
			closeOnClick={false}
			className='tooltip-renda'
		>
			<header>
				<strong className='tooltip-renda__municipi'>{dades.municipi}</strong>
				<p className='tooltip-renda__seccio'>
					{textos.districte} {dades.districte.padStart(2, '0')} | {textos.seccio}{' '}
					{dades.seccio.padStart(3, '0')}
				</p>
			</header>
			<p className='tooltip-renda__valor'>
				<span>{textos.rendaNeta}</span>
				<strong>{renda}</strong>
			</p>
		</PopupComponent>
	)
}
